/* eslint import/prefer-default-export: 0 */
import remote from './remote';

export function getTrainerChallenges(query = {}) {
  return remote.get('trainers', query);
}
